import {L} from "../lt-ng/landcare-toolkit";
import LayerService = L.util.LayerService;

export function IconForClass(classNo: number, layerService: LayerService) {
    if (!layerService) return null;

    // let adjust = layerService.layerName === 'smap_nzsc_order' ? 1 : 0;
    const adjust = layerService.layerName === 'smap_nzsc_order' ? 0 :-1;
    // const adjust = 0;

    return L.util.Layer.iconForClass(layerService, classNo + adjust, {
        parseKeyValue: (qString) => {
            const result = {};
            const usp = new URLSearchParams(qString[0] === '?' ? qString.substr(1) : qString);
            (<any> usp).forEach((v, k) => result[k] = v);
            return result;
        },
        toKeyValue: (params: object) => {
            return `${new URLSearchParams(<any> params)}`;
        }
    });
}